import axios from 'axios'

const API = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
});

const Auth = {
  whoAmI: function () {
    return API.get('whoami')
      .then(resp => resp.data);
  },

  login: function (_API, user) {
    return new Promise ((resolve, reject) => {
      _API.post('login', user)
        .then(resp => {
          const token = resp.data.token;
          localStorage.setItem('user-token', token); // store the token in localstorage
          this.setApiToken(_API);
        })
        .then(() => {
          return this.whoAmI();
        })
        .then(user => {
          localStorage.setItem('user', JSON.stringify(user));
          resolve();
        })
        .catch(err => {
          localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
          localStorage.removeItem('user'); // if the request fails, remove any possible user token if possible
          reject(err);
        })
    })
  },

  setApiToken(_API) {
    let token = localStorage.getItem('user-token');
    _API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },

  get user() {
    let user = localStorage.getItem('user');
    if (!user) return undefined;
    return JSON.parse(user);
  },

  get isAuthenticated() {
    return !!this.token;
  },

  get token() {
    return localStorage.getItem('user-token');
  },

  logout: function (_API) {
    localStorage.removeItem('user-token');
    localStorage.removeItem('user');
    delete _API.defaults.headers.common['Authorization'];
  }
};
export {API, Auth}
